"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OnlineDriversEdSettingsController = /** @class */ (function () {
    function OnlineDriversEdSettingsController($rootScope, $state, OnlineDriversEd, PoliciesModel, FlashService, PoliciesStoreService) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.OnlineDriversEd = OnlineDriversEd;
        this.PoliciesModel = PoliciesModel;
        this.FlashService = FlashService;
        this.PoliciesStoreService = PoliciesStoreService;
        this.policies = {
            onlinedriversed: {
                id: 0,
                policymeta: {
                    success_message: "",
                },
            },
        };
        this.handleSuccessMessageChange =
            this.handleSuccessMessageChange.bind(this);
        var odePolicy = PoliciesStoreService.getPolicy("onlinedriversed");
        if (odePolicy) {
            this.policies.onlinedriversed.id = odePolicy.id;
            this.policies.onlinedriversed.policymeta = {
                success_message: odePolicy.policymeta.success_message || "",
            };
        }
        this.busy = false;
        this.loading = false;
    }
    OnlineDriversEdSettingsController.prototype.handleSuccessMessageChange = function (data) {
        this.policies.onlinedriversed.policymeta.success_message = data.html;
    };
    OnlineDriversEdSettingsController.prototype.processPolicy = function () {
        var _this = this;
        this.busy = true;
        this.PoliciesModel.update({
            id: this.policies.onlinedriversed.id,
            success_message: this.policies.onlinedriversed.policymeta.success_message,
        })
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.PoliciesStoreService.writePolicy("onlinedriversed", {
                success_message: _this.policies.onlinedriversed.policymeta.success_message,
            });
            _this.busy = false;
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    return OnlineDriversEdSettingsController;
}());
exports.default = OnlineDriversEdSettingsController;
OnlineDriversEdSettingsController.$inject = [
    "$rootScope",
    "$state",
    "OnlineDriversEd",
    "PoliciesModel",
    "FlashService",
    "PoliciesStoreService",
];
